import { render, staticRenderFns } from "./Users_profile.vue?vue&type=template&id=454dc7fa&scoped=true&lang=pug&"
import script from "./Users_profile.vue?vue&type=script&lang=coffee&"
export * from "./Users_profile.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454dc7fa",
  null
  
)

export default component.exports